/// <reference path="../include.ts" />

module gpx_visualizer_phase2 {

	export class ControllerSeekBarEvent extends alm.event.Event {

		public static SEEK:string = "ControllerSeekEvent.SEEK";
		public static DRAG_START:string = "ControllerSeekEvent.DRAG_START";
		public static DRAG_END:string = "ControllerSeekEvent.DRAG_END";





		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(eventType:string, target:object, ratio:number) {
			super(eventType, target);
			this.ratio = ratio;
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getRatio():number {
			return this.ratio;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private ratio:number;
	}
}
